export enum ROUTE {
  ACCOUNT = '/account',
  ACHIEVEMENTS = '/achievements',
  ARTICLE_WIDGETS_CLAIM_POINTS = '/article-widgets/claim-points',
  AUTH = '/auth',
  CONNECTED_ACCOUNTS = '/connected-accounts',
  CREDIT_CHECK = '/credit-check',
  DEEPLINK = '/deeplink',
  ENERGY = '/energy',
  ENERGY_PROFILE = '/energy-profile',
  ELECTRICITY_USAGE = '/home/electricity-usage',
  FINANCE_ACCOUNTS = '/finance-accounts',
  FINANCE_ACCOUNTS_DETAIL = '/finance-accounts/$id',
  FINANCE_ACCOUNTS_UPDATE_PAYMENT_METHOD = '/finance-accounts/$financeAccountId/update-payment-method',
  HOME = '/home',
  HOME_PROJECT_DETAIL = '/home/projects/$id',
  ROOT = '/',
  LEARNING_CENTER = '/learn',
  LEARNING_CENTER_CATEGORY = '/learn/$category',
  LEARNING_CENTER_ARTICLE = '/learn/$category/$uid',
  LOGIN_SIGNUP_CHOICE = '/login-signup-choice',
  LOGOUT = '/logout',
  NOTIFICATIONS = '/notifications',
  ONBOARDING = '/onboarding',
  ONBOARDING_DEPRECATED_ENERGY_BILL = '/onboarding/energy-bill',
  TITLE_VERIFICATION = '/onboarding/title-verification',
  PAGE_NOT_FOUND = '/404',
  PAYMENT_SETUP = '/payment/setup',
  PROFILE = '/profile',
  PROJECT_DETAIL = '/projects/$id',
  ENERGY_PLAN_EDUCATION = '/projects/$id/energy-plan-education',
  COMFORT_PLAN_HVAC_EDUCATION = '/projects/$id/comfort-plan-hvac-education',
  BILLING_EDUCATION = '/projects/$id/billing-education',
  SEASONALITY_EDUCATION = '/projects/$id/seasonal-education',
  PROJECT_LOADING = '/project-loading',
  PROPERTIES_BUILDING_ATTRIBUTE_UPDATE = '/properties/$propertyId/building/$buildingAttribute',
  QUESTIONNAIRE = '/questionnaire/$id',
  REFER = '/refer',
  SERVICE = '/service',
  SERVICE_HISTORY = '/service/history',
  SERVICE_HISTORY_DETAIL = '/service/history/$id',
  SHOP = '/shop',
  SHOP_PRODUCTS = '/shop/products/$category',
  SHOP_SEARCH = '/shop/search',
  SIGNUP = '/signup',
  SOLAR = '/home/solar',
  SUPPORT = '/support', // deprecated
  UTILITY_BILL_UPLOAD = '/utility-bill-upload',
  UTILITY_PROVIDER = '/utility-provider',
  UTILITY_RATE_PLAN_CHOOSE_PLAN = '/utility-rate-plan-choose-plan',
  UTILITY_RATE_PLAN_ENROLLMENT = '/utility-rate-plan-enrollment',
  UTILITY_RATE_PLAN_ENROLLMENT_LANDING = '/utility-rate-plan-enrollment-landing',
  UTILITY_RATE_PLAN_OPT_OUT = '/utility-rate-plan-opt-out',
  WELCOME = '/welcome',
  OAUTH_CALLBACK = '/oauth/callback',
  BANK_VERIFICATION = '/payment/bank-verification',
  PLAID_DEMO = '/plaid-demo',
}
